// 分页定义
export const pagination = {
  pageIndex: 1,
  pageSize: 20,
  total: 0
};
export const pagination1 = {
  current_page: 1,
  page_size: 20,
  total_rows: 0
};
// export const pagination2 = {
//   pageIndex: 1,
//   pageSize: 10,
//   total: 0
// };
// 订单列表
export const ordertype = [
  {
    value: 0,
    label: "全部"
  },
  {
    value: 1,
    label: "待付款"
  },
  {
    value: 2,
    label: "待发货"
  },
  {
    value: 3,
    label: "已取消"
  },
  {
    value: 4,
    label: "已发货"
  },
  {
    value: 5,
    label: "已完成"
  }
];
// 商品分类列表
export const checktype = [
  {
    value: 0,
    label: "全部"
  },
  {
    value: 1,
    label: "已上架"
  },
  {
    value: 2,
    label: "已售罄"
  },
  {
    value: 3,
    label: "未上架"
  }
];
// 商品类别
export const goodtype = [
  {
    value: 0,
    label: "实体商品"
  },
  {
    value: 1,
    label: "虚拟商品"
  },
  {
    value: 2,
    label: "AI绘图"
  },
  {
    value: 3,
    label: "定制商品"
  }
];
// 商品类别
export const goodtypeNotAi = [
  {
    value: 0,
    label: "实体商品"
  },
  {
    value: 1,
    label: "虚拟商品"
  },
  {
    value: 3,
    label: "定制商品"
  }
];
// 优惠卷类别
export const coupontype = [
  {
    value: 1,
    label: "满减券"
  },
  {
    value: 2,
    label: "折扣券"
  },
  {
    value: 3,
    label: "代金券线上"
  },
  {
    value: 4,
    label: "代金券线下"
  },
  {
    value: 5,
    label: "专享券"
  }

];
// 有效期
export const datetype = [
  {
    value: 1,
    label: "指定有效天数"
  },
  {
    value: 2,
    label: "指定有效日期"
  }
];
// 限定商品
export const specialGoodsType = [
  {
    value: 1,
    label: "全部商品"
  },
  {
    value: 2,
    label: "指定分类"
  },
  {
    value: 3,
    label: "指定商品"
  }
];
// 订单状态
export const orderstatus = [
  {
    value: 0,
    label: "待付款"
  },
  {
    value: 1,
    label: "待发货"
  },
  {
    value: 2,
    label: "待收货"
  },
  {
    value: 3,
    label: "待评价"
  },
  {
    value: 4,
    label: "已取消"
  },
  {
    value: 5,
    label: "已完成"
  },
  {
    value: 6,
    label: "退款申请中"
  },
  {
    value: 7,
    label: "已通过"
  },
  {
    value: 8,
    label: "退款成功"
  },
  {
    value: 9,
    label: "已拒绝"
  }
];
// 商品提成
export const commype = [
  {
    value: 0,
    label: "每件商品固定提成"
  },
  {
    value: 1,
    label: "成交价"
  }
];

// 分销佣金设置
export const commset = [
  {
    value: 0,
    label: "应用全局规则"
  },
  {
    value: 1,
    label: "自定义"
  }
];
// 物流设置
export const logisticsset = [
  {
    value: 0,
    label: "需要物流"
  },
  {
    value: 1,
    label: "不需要物流"
  }
];
// 上架状态
export const issale = [
  {
    value: 0,
    label: "暂不上架"
  },
  {
    value: 1,
    label: "即时上架"
  }
];
// 爆款状态
export const ishot = [
  {
    value: 0,
    label: "否"
  },
  {
    value: 1,
    label: "是"
  }
];
// 店铺推荐状态
export const isrecommend = [
  {
    value: 0,
    label: "否"
  },
  {
    value: 1,
    label: "是"
  }
];
// 限时优惠状态
export const ischeap = [
  {
    value: 0,
    label: "否"
  },
  {
    value: 1,
    label: "是"
  }
];
// 新品状态
export const isnew = [
  {
    value: 0,
    label: "否"
  },
  {
    value: 1,
    label: "是"
  }
];
// 是否允许支付
export const ispay = [
  {
    value: 0,
    label: "支持线上支付"
  },
  {
    value: 1,
    label: "仅线上展示"
  }
];
// 规格设置
export const isattr = [
  {
    value: 0,
    label: "单规格"
  },
  {
    value: 1,
    label: "多规格"
  }
];

// 商城页面名称
export const detailshowtype = [
  {
    value: 0,
    label: "显示商品名称"
  },
  {
    value: 1,
    label: "自定义内容"
  }
];

// 售后管理筛选类型
export const aftersaletype = [
  {
    value: 0,
    label: "全部"
  },
  {
    value: 1,
    label: "申请中"
  },
  {
    value: 2,
    label: "已通过"
  },
  {
    value: 3,
    label: "已完成"
  },
  {
    value: 4,
    label: "已拒绝"
  }
];

// 是否显示线下提成
export const commissionshowtype = [
  {
    value: 0,
    label: "显示"
  },
  {
    value: 1,
    label: "不显示"
  }
];
// 包邮(0否、1是)
export const isfree = [
  {
    value: 0,
    label: "否"
  },
  {
    value: 1,
    label: "是"
  }
];

// 商品提成
export const commtype = [
  {
    value: 0,
    label: "每件商品固定提成"
  },
  {
    value: 1,
    label: "成交价"
  }
];
// 计费方式
export const costtype = [
  {
    value: 0,
    label: "按件数"
  },
  {
    value: 1,
    label: "按重量"
  }
];
// 内容类型
export const contenttype = [
  {
    value: 1,
    label: "订单编号"
  },
  {
    value: 2,
    label: "收货人姓名"
  },
  {
    value: 3,
    label: "收货人电话"
  }
];
// 折扣类型
export const discounttype = [
  {
    value: 0,
    label: "基础折扣"
  },
  {
    value: 1,
    label: "个人指定折扣"
  }
];

// 价格展示自定义
export const showtype = [
  {
    value: 0,
    label: "展示文字与价格区间"
  },
  {
    value: 1,
    label: "仅显示文字"
  }
];
// 快递运费类型（0、1）
export const shippingset = [
  {
    value: 0,
    label: "统一运费"
  },
  {
    value: 1,
    label: "运费模板"
  }
];
//商品类型(0全部、1实体商品 - 仅线上展示、2实体商品 - 支持线上支付、3虚拟商品)
export const goodstype = [
  {
    value: 0,
    label: "全部"
  },
  {
    value: 1,
    label: "实体商品 - 仅线上展示"
  },
  {
    value: 2,
    label: "实体商品 - 支持线上支付"
  },
  {
    value: 3,
    label: "虚拟商品"
  }
];
//退款类型(0全部、1退货退款、2未发货仅退款、3已发货退款)
export const refundtype = [
  {
    value: 0,
    label: "全部"
  },
  {
    value: 1,
    label: "退货退款"
  },
  {
    value: 2,
    label: "未发货仅退款"
  },
  {
    value: 3,
    label: "已发货退款"
  }
];
//退款类型(0全额退款、1自定义金额退款)
export const refundmoneytype = [
  {
    value: 0,
    label: "全额退款"
  },
  {
    value: 1,
    label: "自定义金额退款"
  }
];
// 来源
export const customerType = [{
  value: '1',
  label: '转发'
}, {
  value: '2',
  label: '扫码'
}, {
  value: '3',
  label: '名片转发'
}, {
  value: '4',
  label: '海报分享'
}, {
  value: '5',
  label: '搜索'
}, {
  value: '6',
  label: '小程序官网'
}, {
  value: '7',
  label: '工作交接'
}, {
  value: '8',
  label: '特权优惠卷'
}, {
  value: '9',
  label: '获客文章'
}, {
  value: '10',
  label: '同事名片'
}, {
  value: '11',
  label: '获客海报'
}, {
  value: '12',
  label: '动态海报'
}];

// 查询字典名称
export function getlabelbykey(arr, key) {
  let label = "";
  if (arr && arr.length > 0) {
    arr.forEach(item => {
      if (item.value === key) {
        label = item.label;
      }
    });
  }
  return label;
}
